module.exports = __webpack_public_path__ + "img/fireworks.ddd14645.png";